<template>
  <div class="container-fluid mtb15 no-fluid">
    <div class="row sm-gutters">
      <!-- Menu -->
      <div v-if="1200 < getWindowsWidth" class="col-sm-12 col-md-2">
        <AppMenu></AppMenu>
      </div>
      <div class="col-sm-12" :class="{ 'col-md-10': 1200 < getWindowsWidth }">
        <!-- header -->
        <div class="row align-items-center wallet-detail-header">
          <div class="col-sm-1 wallet-detail-back">
            <!-- back button -->
            <button
              class="btn btn btn-outline-secondary btn-light mb-2"
              :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }"
              @click.prevent="goBack()"
            >&larr;</button>
          </div>
          <div class="col-sm-11 wallet-detail-title">
            <!-- view header -->
            <h5 v-if="1200 < getWindowsWidth">{{ getTradesLabel }} - #{{ trade?.oid }}</h5>
            <h6 v-else>{{ getTradesLabel }} - #{{ trade?.oid }}</h6>
          </div>
        </div>
        <!-- trade details -->
        <div class="table-responsive">
          <table class="table trade-details-table">
            <tbody>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getStatusLabel }}</td>
                <td
                  class="prop-value"
                  :class="[getTradeStatusClass(trade), { 'xsmall-font-size': 1200 > getWindowsWidth }]"
                >
                  {{ getTradeStatus(trade) }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getTradeIdLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ tradeIdentifier }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getOrderIdLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ trade?.oid }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getTimestampLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ getDate(trade?.ts) }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getTypeLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ getOrderType(trade?.tt) }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getOrderTypeLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ tradeOrderType }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getCodeLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ trade?.sc }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getNameLabel }}</td>
                <td
                  v-if="0 === 'BG'.localeCompare(getUserLanguage)"
                  class="prop-value"
                  :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }"
                >
                  {{ trade?.nBG ? trade?.nBG : trade?.nEN }}
                </td>
                <td
                  v-if="0 === 'EN'.localeCompare(getUserLanguage)"
                  class="prop-value"
                  :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }"
                >
                  {{ trade?.nEN }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getExchangeLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ tradeExchangeCode }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getInstrumentTypeLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ getInstrumentType(trade?.stid) }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getQuantityOrFaceValueLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ formatQuantityOrFaceValue(getQuantityOrFaceValue()) }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getPriceLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ formatTradePrice(trade?.sp) }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getFeeLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ formatMoney(trade?.fee || 0) }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getTotalAmountLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ formatMoney(getTotalAmount()) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

import AppMenu from "@/components/ui/AppMenu.vue";
import I18n from "@/lang/i18n.js";
import UiUtils from "@/assets/js/ui_utils.js";
import type { Trade } from "@/features/wallet/types";
import { getBackendOrderTypeLabel, getOrderActionLabel } from "@/features/wallet/wallet-label-formatters";
import { getStockTypeLabel } from "@/features/stocks/stock-type-labels";

export default {
  components: { AppMenu },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();

    const getWindowsWidth = computed(
      () => (store.getters["getAppWindowWidth"] as number | undefined) || window.innerWidth
    );

    const tradeId = computed(() => {
      const fromRoute = route.params.tradeId as string | string[] | undefined;

      const selectedId = store.state.wallet
        ? (store.state.wallet.selectedTradeId as string | null | undefined)
        : null;

      const normalizedRouteId =
        Array.isArray(fromRoute) ? fromRoute[0] : fromRoute;

      return String(normalizedRouteId ?? selectedId ?? "");
    });

    const getUserLanguage = computed(
      () =>
        (store.getters["getNonLoggedInLanguage"] as string | undefined)?.toUpperCase() ||
        "EN"
    );

    const t = (key: string, ...args: unknown[]): string => {
      return I18n.t(key, getUserLanguage.value, ...args);
    };

    const orderFormatterLabels = computed(() => ({
      buy: t("buyLabel"),
      sell: t("sellLabel")
    }));

    const backendOrderTypeLabels = computed(() => ({
      market: t("marketLabel"),
      limit: t("limitLabel"),
      stopLimit: t("stopLimitLabel"),
      stopMarket: t("stopMarketLabel"),
      iceberg: t("icebergLabel")
    }));

    const stockTypeLabels = computed(() => ({
      bonds: t("bondsLabel"),
      cfd: t("cfdLabel"),
      compInstruments: t("compInstrumentsLabel"),
      equities: t("equitiesLabel"),
      funds: t("fundsLabel"),
      margin: t("marginLabel"),
      netting: t("nettingLabel"),
      reits: t("reitsLabel"),
      repo: t("repoLabel"),
      rights: t("rightsLabel"),
      stocksAndEtfs: t("stocksAndEtfsLabel"),
      other: t("othersLabel"),
      unknown: t("othersLabel")
    }));

    const getDate = (
      value: string | number | Date | null | undefined
    ): string => {
      if (value == null) return "";
      if (value instanceof Date) {
        return UiUtils.parseUnixMsTime(value.getTime());
      }
      if (typeof value === "number") {
        return value < 10_000_000_000
          ? UiUtils.parseUnixTime(value)
          : UiUtils.parseUnixMsTime(value);
      }

      const parsed = Date.parse(value);
      return Number.isNaN(parsed) ? String(value) : UiUtils.parseUnixMsTime(parsed);
    };

    const getOrderType = (
      action: string | null | undefined
    ): string => {
      return getOrderActionLabel(action, orderFormatterLabels.value);
    };

    const trade = computed<Trade | null>(() => {
      const id = tradeId.value;

      const byIdGetter = store.getters["wallet/tradeById"] as
        | ((id: string | number) => Trade | null | undefined)
        | undefined;

      const selected =
        (store.state.wallet?.selectedTrade as Trade | null | undefined) ?? null;

      if (byIdGetter && id) {
        const found = byIdGetter(id);
        if (found) {
          return {
            ...(found as Record<string, unknown>),
            ...(selected as Record<string, unknown> | null ?? {})
          } as unknown as Trade;
        }
      }

      return selected;
    });

    const toNumber = (
      value: number | string | null | undefined
    ): number => {
      if (value == null) {
        return 0;
      }

      const num = typeof value === "string" ? Number(value) : value;
      return Number.isFinite(num) ? num : 0;
    };

    const parseNumber = (
      num: number | string | null | undefined,
      afterDot = 2
    ): string => {
      if (num == null) {
        return "";
      }

      return UiUtils.formatNumber(toNumber(num), afterDot);
    };

    const isBondTrade = computed(() => 2 === Number.parseInt(String(trade.value?.stid ?? ""), 10));

    const formatMoney = (
      value: number | string | null | undefined
    ): string => {
      return UiUtils.formatPrice(
        toNumber(value),
        trade.value?.cc,
        getUserLanguage.value,
        2
      );
    };

    const formatTradePrice = (
      value: number | string | null | undefined
    ): string => {
      if (isBondTrade.value) {
        return `${parseNumber(value, 3)}%`;
      }

      return UiUtils.formatPrice(
        toNumber(value),
        trade.value?.cc,
        getUserLanguage.value,
        2
      );
    };

    const getTradeField = (
      currentTrade: Trade | null | undefined,
      keys: string[]
    ): unknown => {
      const rec = currentTrade as unknown as Record<string, unknown> | null | undefined;
      if (!rec) {
        return null;
      }

      for (const key of keys) {
        const value = rec[key];
        if (value !== undefined && value !== null && "" !== String(value)) {
          return value;
        }
      }

      return null;
    };

    const tradeIdentifier = computed(() => {
      const value = getTradeField(trade.value, ["trid", "tid", "trade_id", "id"]);
      return value == null ? "" : String(value);
    });

    const tradeExchangeCode = computed(() => {
      const currentTrade = trade.value;
      if (!currentTrade) {
        return "";
      }

      const maybe = getTradeField(currentTrade, [
        "xc",
        "xcode",
        "xCode",
        "exchange",
        "exchangeCode",
        "ex",
        "x"
      ]);

      if (maybe != null) {
        return String(maybe);
      }

      const stockCode = getTradeField(currentTrade, ["sc", "code"]);
      if (stockCode == null) {
        return "";
      }

      const stocks = (store.getters["getStocks"] ?? []) as Record<string, unknown>[];
      const matches = stocks.filter((stock) => {
        const code = stock.code;
        return code != null &&
          String(code).toUpperCase() === String(stockCode).toUpperCase();
      });

      const currentStockType = getTradeField(currentTrade, ["stid", "stockType"]);
      const matchedStock = matches.find((stock) =>
        currentStockType == null ||
        String(stock.stid ?? stock.stockType ?? "") === String(currentStockType)
      ) ?? matches[0];

      const exchangeId = matchedStock?.cMIC;
      if (exchangeId == null) {
        return "";
      }

      return UiUtils.getExchangeCodeById(
        store.getters["getExchanges"],
        exchangeId
      );
    });

    const tradeOrderType = computed(() => {
      const currentTrade = trade.value;
      const orderType =
        getTradeField(currentTrade, ["ot"]) ??
        getTradeField(currentTrade, ["orderType", "order_type"]);

      return getBackendOrderTypeLabel(orderType, backendOrderTypeLabels.value);
    });

    const getInstrumentType = (
      stockType: number | string | null | undefined
    ): string => {
      return getStockTypeLabel(stockType, stockTypeLabels.value);
    };

    const getQuantityOrFaceValue = (): number => {
      const currentTrade = trade.value;
      if (!currentTrade) {
        return 0;
      }

      const qty = toNumber(currentTrade.qty as number | string | undefined);
      if (!isBondTrade.value) {
        return qty;
      }

      return UiUtils.getBondDisplayFaceValue(currentTrade, qty);
    };

    const formatQuantityOrFaceValue = (
      value: number | null | undefined
    ): string => {
      if (value == null) {
        return "";
      }

      return UiUtils.formatNumber(value, Number.isInteger(value) ? 0 : 2);
    };

    const getTotalAmount = (): number => {
      const currentTrade = trade.value;
      if (!currentTrade) {
        return 0;
      }

      const amount = toNumber(currentTrade.pt as number | string | undefined);
      const fee = toNumber(currentTrade.fee as number | string | undefined);
      const type = String(currentTrade.tt ?? "").toLowerCase();

      return "b" === type ? amount + fee : amount - fee;
    };

    const getTradeStatus = (
      currentTrade: Trade | null | undefined
    ): string => {
      const status = Number.parseInt(String(getTradeField(currentTrade, ["sts", "status"]) ?? ""), 10);
      if (Number.isNaN(status)) {
        return currentTrade ? t("filledLabel") : "";
      }

      return 5 === status ? t("filledLabel") : "";
    };

    const getTradeStatusClass = (
      currentTrade: Trade | null | undefined
    ): string => {
      const status = Number.parseInt(String(getTradeField(currentTrade, ["sts", "status"]) ?? ""), 10);
      if (Number.isNaN(status)) {
        return currentTrade ? "trade-status-filled" : "trade-status-default";
      }

      return 5 === status ? "trade-status-filled" : "trade-status-default";
    };

    const goBack = () => {
      router.push({
        name: "Wallet",
        query: { latestActiveMenuSelection: "Trades" }
      });
    };

    const getTradesLabel = computed(() => t("tradesLabel"));
    const getStatusLabel = computed(() => t("statusLabel"));
    const getTradeIdLabel = computed(() => t("tradeIdLabel"));
    const getOrderIdLabel = computed(() => t("orderLabel"));
    const getTimestampLabel = computed(() => t("timestampLabel"));
    const getTypeLabel = computed(() => t("typeLabel"));
    const getOrderTypeLabel = computed(() => t("orderTypeLabel"));
    const getCodeLabel = computed(() => t("codeLabel"));
    const getNameLabel = computed(() => t("nameLabel"));
    const getExchangeLabel = computed(() => t("exchangeLabel"));
    const getInstrumentTypeLabel = computed(() => t("instrumentTypeLabel"));
    const getQuantityOrFaceValueLabel = computed(() => isBondTrade.value ? t("faceValueLabel") : t("numberOfSharesLabel"));
    const getPriceLabel = computed(() => t("priceLabel"));
    const getFeeLabel = computed(() => t("feeLabel"));
    const getTotalAmountLabel = computed(() => t("totalAmountLabel"));

    return {
      // navigation & ids
      tradeId,
      trade,
      goBack,

      // layout
      getWindowsWidth,
      getUserLanguage,

      // labels
      getTradesLabel,
      getStatusLabel,
      getTradeIdLabel,
      getOrderIdLabel,
      getTimestampLabel,
      getTypeLabel,
      getOrderTypeLabel,
      getCodeLabel,
      getNameLabel,
      getExchangeLabel,
      getInstrumentTypeLabel,
      getQuantityOrFaceValueLabel,
      getPriceLabel,
      getFeeLabel,
      getTotalAmountLabel,

      // helpers
      getDate,
      getOrderType,
      tradeOrderType,
      getInstrumentType,
      getQuantityOrFaceValue,
      formatQuantityOrFaceValue,
      getTotalAmount,
      getTradeStatus,
      getTradeStatusClass,
      parseNumber,
      formatMoney,
      formatTradePrice,
      tradeIdentifier,
      tradeExchangeCode
    };
  },
};
</script>

<style scoped>
.wallet-detail-header {
  flex-wrap: nowrap;
}

.wallet-detail-back {
  flex: 0 0 auto;
  width: auto;
}

.wallet-detail-title {
  flex: 1 1 auto;
  width: auto;
}

.wallet-detail-title h5,
.wallet-detail-title h6 {
  margin-bottom: 0.5rem;
}

.prop-value {
  text-align: right;
  font-weight: bold;
}

.trade-details-table td {
  font-size: 1rem;
  line-height: 1.35;
  padding: 0.6rem 0.5rem;
}

.trade-status-filled {
  color: green;
}

.trade-status-default {
  color: black;
}

.xxsmall-font-size {
  font-size: xx-small;
}

.xsmall-font-size {
  font-size: 1rem;
}
</style>
